
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class Modal extends Vue {
  isModal = false;
  closeOnBack = true;

  onClickOpenModal() {
    document.body.style.overflowY = 'hidden';
    this.isModal = true;
  }
  onClickCloseModal() {
    document.body.style.overflowY = 'auto';
    this.isModal = false;
  }
}
